export default __webpack_public_path__ + "static/media/robot.0f6cba82.svg";